import SetState from './setState';

const args = {
    sel: '[href="#newsletter"]',
    item: '.newsletter-popup',
    close: '.page-popup-close, .newsletter-wrapper-success .btn',
};

const popup = new SetState(args);

export default popup;
